import requests from '../requests'

export default {
  find (ref) {
    return requests.post('lookup', { ref })
  }
}
